import * as React from 'react';

import FileCanvas32 from './FileCanvas32';

export const fileCanvas32 = () => <FileCanvas32 />;

export default {
    title: 'Icon/Content/FileCanvas32',
    component: FileCanvas32,
    parameters: {
        notes: "`import FileCanvas32 from 'box-ui-elements/es/icon/content/FileCanvas32';`",
    },
};
